import {DepositFix} from './app';

export class DepositFixAPI {

    private df: DepositFix;

    constructor(widget: DepositFix) {
        this.df = widget;
    }

    public onElementChange(selector: string, callback: Function) {
        const htmlElement = this.getElement(selector);

        htmlElement.addEventListener('change', (event) => {
            callback(event.target);
        });
    }

    public getElement(selector: string): HTMLElement {
        return this.df.view.getFromHSFrame(selector) ||
            this.df.view.getHtmlElement(selector);
    }

    public getValue(selector: string): string {
        const element = <HTMLInputElement> this.getElement(selector);
        if (element) {
            return element.value;
        }

        return '';
    }

    public getValueByName(selector: string): string {
        return this.getValue(`[name=${selector}]`);
    }

    public setValue(selector: string, value: string) {
        const element = <HTMLInputElement> this.getElement(selector);
        if (element) {
            element.value = value;
            element.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    public setSelectedIndex(selector: string, index: any) {
        const element = <HTMLSelectElement> this.getElement(selector);
        if (element) {
            element.selectedIndex = Number(index);
            element.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }

    public hide(selector: string) {
        const element = this.getElement(selector);
        if (element) {
            element.style.display = 'none';
        }
    }

    public show(selector: string) {
        const element = this.getElement(selector);
        if (element) {
            element.style.display = 'block';
        }
    }

    public setTax(tax: number) {
        this.df.widget.getSettings().tax = tax;
        this.df.widget.triggerAmount();
    }

}
